module.exports = __webpack_public_path__ + "img/m-plan-2-BG.ddd2a699.png";